import gql from 'graphql-tag'

export const queryContractFieldsByPk = id => {
	return {
		query: gql`
			query ($id: bigint!) {
				pdf_fields_by_pk(id: $id) {
					db_field_name
					db_table_name
					field_name
					field_variable
				}
			}
		`,
		update(data) {
			return {
				tableName: data.pdf_fields_by_pk.db_table_name,
				fieldName: data.pdf_fields_by_pk.db_field_name,
				name: data.pdf_fields_by_pk.field_name,
				variable: data.pdf_fields_by_pk.field_variable
			}
		},
		variables: {
			id: parseInt(id)
		}
	}
}
